/** Remove inline base64 images so event description JSON stays small on save. */
export function stripDataUriImagesFromHtml(html: string): string {
  if (!html) {
    return html;
  }

  return html.replace(/<img\b[^>]*\ssrc=["']data:image[^"']*["'][^>]*>/gi, '');
}
